export const em = (text: string) => `<em>${text}</em>`
